/**
 * Does not work on classes
 */
export function clone(value: Object) {
  if (!value) {
    return value;
  }
  return JSON.parse(JSON.stringify(value));
}
